"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _isCvvRequired = _interopRequireDefault(require("../utils/isCvvRequired"));

var _CardSelect = _interopRequireDefault(require("../../CardSelect"));

var _Base = require("../../Base");

var _AnimateHeight = _interopRequireDefault(require("../../AnimateHeight"));

var _cardholder = _interopRequireDefault(require("../cardholder"));

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _CvvInput = _interopRequireDefault(require("../../CvvInput"));

var _hint = _interopRequireDefault(require("../hint"));

var _InfoItalic = _interopRequireDefault(require("@p24/icons/InfoItalic"));

var _hintContainer = _interopRequireDefault(require("../style/manual/hintContainer"));

var _cvv = _interopRequireDefault(require("../style/wallet/cvv"));

var _PropTypes$shape, _PropTypes$shape2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var cvvDefaultProps = {
  label: 'DEBIT_SOURCE_WALLET_LABEL_CVV',
  floating: false
};
var cardDefaultProps = {
  selectFirst: true,
  simple: false,
  maxLength: 6
};

var Wallet = function Wallet(_ref) {
  var onChange = _ref.onChange,
      cardholder = _ref.cardholder,
      value = _ref.value,
      list = _ref.list,
      debit = _ref.debit,
      wallet = _ref.wallet,
      disabled = _ref.disabled,
      error = _ref.error,
      attribute = _ref.attribute,
      theme = _ref.theme,
      cvvHint = _ref.cvvHint;
  var firstName = (0, _react.useRef)(null);
  var handleChange = (0, _react.useCallback)(function (data) {
    if (typeof onChange === 'function') {
      var _objectSpread2;

      onChange(_objectSpread((_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, _constants.ATTR_CARD_ID, null), (0, _defineProperty2["default"])(_objectSpread2, _constants.ATTR_CVV, undefined), (0, _defineProperty2["default"])(_objectSpread2, _constants.ATTR_LAST_NAME, cardholder ? null : undefined), (0, _defineProperty2["default"])(_objectSpread2, _constants.ATTR_FIRST_NAME, cardholder ? null : undefined), _objectSpread2), value, {}, data, {
        source: _constants.SOURCE_WALLET
      }));
    }
  }, [onChange, cardholder, value]);
  var onCardChange = (0, _react.useCallback)(function (e) {
    var _handleChange;

    handleChange((_handleChange = {}, (0, _defineProperty2["default"])(_handleChange, _constants.ATTR_CARD_ID, e.target.value), (0, _defineProperty2["default"])(_handleChange, _constants.ATTR_CVV, (0, _isCvvRequired["default"])(e.target.value, list, debit) ? value && value[_constants.ATTR_CVV] || null : undefined), _handleChange));
  }, [value, list, debit]);
  var onFirstNameChange = (0, _react.useCallback)(function (value) {
    return handleChange((0, _defineProperty2["default"])({}, _constants.ATTR_FIRST_NAME, value));
  }, [value]);
  var onLastNameChange = (0, _react.useCallback)(function (value) {
    return handleChange((0, _defineProperty2["default"])({}, _constants.ATTR_LAST_NAME, value));
  }, [value]);
  var onCvvChange = (0, _react.useCallback)(function (e) {
    return handleChange((0, _defineProperty2["default"])({}, _constants.ATTR_CVV, e.target.value));
  }, [value]);

  var _useMemo = (0, _react.useMemo)(function () {
    var _wallet$cvv;

    return [_objectSpread({}, cardDefaultProps, {
      label: _l10n["default"].t(cardDefaultProps.label)
    }, wallet === null || wallet === void 0 ? void 0 : wallet.card, {
      disabled: disabled
    }), _objectSpread({}, cvvDefaultProps, {
      label: _l10n["default"].t(cvvDefaultProps.label)
    }, wallet === null || wallet === void 0 ? void 0 : wallet.cvv, {
      disabled: disabled
    }), _objectSpread({}, wallet === null || wallet === void 0 ? void 0 : (_wallet$cvv = wallet.cvv) === null || _wallet$cvv === void 0 ? void 0 : _wallet$cvv.style, {
      width: '100%'
    })];
  }, [wallet, disabled]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 3),
      cardProps = _useMemo2[0],
      cvvProps = _useMemo2[1],
      cvvStyle = _useMemo2[2];

  (0, _react.useEffect)(function () {
    var _value$ATTR_CVV;

    if (cardholder && value && ((_value$ATTR_CVV = value[_constants.ATTR_CVV]) === null || _value$ATTR_CVV === void 0 ? void 0 : _value$ATTR_CVV.length) === 3) {
      setTimeout(function () {
        return firstName.current.focus();
      }, 0);
    }
  }, [cardholder, value && value[_constants.ATTR_CVV]]);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", null, _react["default"].createElement(_CardSelect["default"], (0, _extends2["default"])({}, cardProps, {
    onChange: onCardChange,
    collection: list,
    value: value && value[_constants.ATTR_CARD_ID],
    error: !!(error && error[_constants.ATTR_CARD_ID]),
    attribute: _constants.ATTR_CARD_ID + attribute
  })), _react["default"].createElement(_Base.FieldError, {
    error: error && error[_constants.ATTR_CARD_ID]
  })), (0, _isCvvRequired["default"])(value && value[_constants.ATTR_CARD_ID], list, debit) ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_cvv["default"], {
    theme: theme
  }, _react["default"].createElement(_CvvInput["default"], (0, _extends2["default"])({}, cvvProps, {
    onChange: onCvvChange,
    value: value && value[_constants.ATTR_CVV],
    error: !!(error && error[_constants.ATTR_CVV]),
    style: cvvStyle,
    attribute: _constants.ATTR_CVV + attribute
  })), cvvHint && _react["default"].createElement(_hint["default"], (0, _extends2["default"])({}, cvvHint, {
    theme: theme
  }), _react["default"].createElement(_hintContainer["default"], {
    theme: theme
  }, _react["default"].createElement(_InfoItalic["default"], null)))), _react["default"].createElement(_Base.FieldError, {
    error: error && error[_constants.ATTR_CVV]
  })) : null, _react["default"].createElement(_AnimateHeight["default"], {
    open: cardholder
  }, _react["default"].createElement(_cardholder["default"], {
    theme: theme,
    disabled: disabled,
    firstName: _objectSpread({}, wallet === null || wallet === void 0 ? void 0 : wallet.firstName, {
      value: value && value[_constants.ATTR_FIRST_NAME],
      onChange: onFirstNameChange,
      attribute: _constants.ATTR_FIRST_NAME + attribute,
      elementRef: firstName,
      error: error && error[_constants.ATTR_FIRST_NAME]
    }),
    lastName: _objectSpread({}, wallet === null || wallet === void 0 ? void 0 : wallet.lastName, {
      value: value && value[_constants.ATTR_LAST_NAME],
      onChange: onLastNameChange,
      attribute: _constants.ATTR_LAST_NAME + attribute,
      error: error && error[_constants.ATTR_LAST_NAME]
    })
  })));
};

Wallet.propTypes = {
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].shape((_PropTypes$shape = {}, (0, _defineProperty2["default"])(_PropTypes$shape, _constants.ATTR_CARD_ID, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape, _constants.ATTR_LAST_NAME, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape, _constants.ATTR_FIRST_NAME, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape, _constants.ATTR_CVV, _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])), _PropTypes$shape)),
  error: _propTypes["default"].shape((_PropTypes$shape2 = {}, (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_CARD_ID, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_LAST_NAME, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_FIRST_NAME, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_CVV, _propTypes["default"].string), _PropTypes$shape2)),
  list: _propTypes["default"].array,
  debit: _propTypes["default"].bool,
  cardholder: _propTypes["default"].bool,
  wallet: _propTypes["default"].object,
  disabled: _propTypes["default"].bool,
  cvvHint: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object])
};
var _default = Wallet;
exports["default"] = _default;